/* eslint-disable @typescript-eslint/naming-convention */
import { useState } from 'react'
import { useComputed, useSignal } from "@preact/signals-react"

import SelectParentBusinessEntityLeaves from "./SelectParentBusinessEntityLeaves.jsx"
import Icon from "../../../components/Icon.jsx"

import { debugSignal } from '../../../state/signals/userSettingsSignals.js'

import { iconForOrgType } from '../../../utils/utils.js'

const SelectParentBusinessEntityLeaf = function ({ businessEntity, type, selectedBusinessEntityIdSignal, selectedBusinessEntityIdsSignal, enableSubmitSignal, depth }) {

	const [manualRerenderState, workaround] = useState(false)
	const rerender = () => {
		workaround(!manualRerenderState)
	}

	const debug = debugSignal.value && false
	const id = businessEntity.id

	/*const checkedComputed = useComputed(
		() => {
			if (type == "radio") {
				return selectedBusinessEntityIdSignal.value == businessEntity.id
			} else if (type == "checkbox") {
				return selectedBusinessEntityIdsSignal.value.has(businessEntity.id)
			}
		}
	)*/

	const checkedSignal = useSignal(type == "checkbox" && selectedBusinessEntityIdsSignal.value.has(businessEntity.id) || type == "radio" && selectedBusinessEntityIdSignal.value == businessEntity.id)

	const check = () => {
		if (type == "radio") {
			selectedBusinessEntityIdSignal.value = businessEntity.id
			if (checkedSignal.value) {
				checkedSignal.value = false
			} else {
				checkedSignal.value = true
			}
			//console.log("selected parent business entity ID:")
			//console.log(selectedBusinessEntityIdSignal.value)
		} else if (type == "checkbox") {
			if (selectedBusinessEntityIdsSignal.value.has(businessEntity.id)) {
				selectedBusinessEntityIdsSignal.value.delete(businessEntity.id)
				if (selectedBusinessEntityIdsSignal.value.size == 0) {
					if (enableSubmitSignal) {
						enableSubmitSignal.value = false
					}
				}
				checkedSignal.value = false
				//rerender()
			} else {
				selectedBusinessEntityIdsSignal.value.add(businessEntity.id)
				if (enableSubmitSignal) {
					enableSubmitSignal.value = true
				}
				checkedSignal.value = true
				//rerender()
			}
			//console.log("The following business entities are selected:")
			//console.log(selectedBusinessEntityIdsSignal.value.values().toArray())
		}
	}

	return (
		<>
			<tr className="selectParentBELeaf" key={id}>
				<td style={{ paddingLeft: (depth * 30).toString().concat('px') }}>
					<Icon icon={iconForOrgType(businessEntity)} height={16} width={16}></Icon>
					&nbsp;{businessEntity.name}
				</td>
				<td className='checkbox-icon'>
					{debug && (<>{id}&nbsp;</>)}
					<label hidden={type == "checkbox" && checkedSignal.value || type == "radio" && selectedBusinessEntityIdSignal.value == businessEntity.id} onClick={check}>
						<Icon style={{ fontSize: "28px", color: "#ccc" }} icon={type == "radio" ? "check-circle" : "check-square"}></Icon>{debug && (<>&nbsp;Off</>)}
					</label>
					<label hidden={type == "checkbox" && !checkedSignal.value || type == "radio" && selectedBusinessEntityIdSignal.value != businessEntity.id} onClick={check}>
						<Icon style={{ fontSize: "28px", color: "#6f2a8e" }} icon={type == "radio" ? "check-circle-fill" : "check-square-fill"}></Icon>{debug && (<>&nbsp;On</>)}
					</label>
				</td>
			</tr>
			{
				(businessEntity.companies.length > 0) ? (
					<SelectParentBusinessEntityLeaves
						businessEntities={businessEntity.companies}
						type={type}
						selectedBusinessEntityIdSignal={selectedBusinessEntityIdSignal}
						selectedBusinessEntityIdsSignal={selectedBusinessEntityIdsSignal}
						enableSubmitSignal={enableSubmitSignal}
						depth={depth + 1}
					></SelectParentBusinessEntityLeaves>
				) : (<></>)
			}
		</>
	)
}
export default SelectParentBusinessEntityLeaf